import { Auditable } from '../shared/auditable.model';
import { UserModel } from './user.model';
import { AssetModel } from './asset.model';
import { AccountModel } from './account.model';
import { VendorModel } from './vendor.model';

export class AssetMaintenanceScheduleModel extends Auditable {
  id: number;
  title: string = '';
  description: string;

  asset_id: number;
  vendor_id: number;
  contractor_account_id: number;

  maintenance_type: string = 'preventive';
  maintenance_type_other: string;
  schedule_mode: string = 'date';
  default_priority: string = 'medium';

  enabled: boolean = true;
  is_recurring: boolean = false;

  is_all_day: boolean = false;
  rrule: string;
  duration_minutes: number;
  schedule_start_at: number;
  schedule_end_at: number;

  auto_create: boolean = false;
  auto_create_lead_time_value: number = 0;
  auto_create_lead_time_unit: string = 'days';

  next_due_at: number;
  last_triggered_at: number;
  next_auto_create_at: number;

  notes: string;

  created_by_user: UserModel;
  updated_by_user: UserModel;

  asset: AssetModel;
  contractor: AccountModel;
  vendor: VendorModel;

  users: UserModel[] = [];
  user_ids: number[] = [];
}
